module.exports = __webpack_public_path__ + "static/media/TB2022_chi_.6cf960c0.jpeg";